module.exports = __webpack_public_path__ + "static/media/Review-Unfinished.23452bd9.png";